import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { PolicyCriteria } from '../policy/policy-list/_models/policy-criteria';
import { API_URL, ENDORSEMENT_URL } from '../_common/constants';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { PolicyListByAccountCriteria } from '../account/policy-list-by-account/_models/policy-list-by-account-criteria';
import { CommonService } from './common.service';
import { ClaimService } from './claim.service';
import { ClaimListByPolicyCriteria } from '../policy/claim-list-by-policy/_models/claim-list-by-policy-criteria';
import { FileDownloadService } from './file-download.service';
import { ModalService } from './modal.service';
import { Modules } from '../_common/_enum/module.enum';

@Injectable({
  providedIn: 'root'
})
export class PolicyService {
  
  constructor(private http: HttpClient, private commonService: CommonService, private claimService: ClaimService, private fileDownloadService: FileDownloadService, private modalService: ModalService) { 
  }

  set header(data){
    this.commonService.header = data;
  }

  get runningServices(){
    return this.commonService.runningServices;
  }

  storePolicyData(policy){
    let psiData = this.commonService.getData();
    psiData.selectedPolicy = policy;
    this.commonService.storeData(psiData);
  }
  
  getPolicyData(){
    let psiData = this.commonService.getData();
    return psiData.selectedPolicy;
  }
  
  storeAccountData(account){
    let psiData = this.commonService.getData();
    psiData.selectedAccount = account;
    this.commonService.storeData(psiData);
  }

  getAccountData(){
    let psiData = this.commonService.getData();
    return psiData.selectedAccount;
  }

  storeClaimData(claim){
    let psiData = this.commonService.getData();
    psiData.selectedClaim = claim;
    this.commonService.storeData(psiData);
  }  


  fetchPolicies(criteria: PolicyCriteria):Observable<HttpResponse<any>> {
    return this.http.post<any>(API_URL.Policy, criteria, {observe: 'response'})
        .pipe(map(polices => {
            return polices.body.result;
        }));
  }
  
  fetchPoliciesByAccount(criteria: PolicyListByAccountCriteria):Observable<HttpResponse<any>> {
    return this.http.post<any>(API_URL.PolicyByAccount, criteria, {observe: 'response'})
        .pipe(map(polices => {
            return polices.body.result;
        }));
  }
  
  // Fetching Account by Account Number from the fetchPoliciesByAccount.
  fetchAccountByAccountNumber(filters: PolicyListByAccountCriteria):Observable<HttpResponse<any>> {
    return this.fetchPoliciesByAccount(filters);
  }


  fetchPolicyDetails(policyNumber: string):Observable<HttpResponse<any>> {
    return this.http.get<any>(API_URL.PolicyDetails+'?policyNumber='+ policyNumber, {observe: 'response'})
        .pipe(map(response => {
            return response.body.result;
        }));
  }

  fetchClaimsByPolicy(filters:ClaimListByPolicyCriteria):Observable<HttpResponse<any>> {
    return this.claimService.fetchClaimsByPolicy(filters);
  }

  fetchAccountByPolicy(policyNumber){
    return this.commonService.fetchAccountByPolicy(policyNumber);
  }

  downloadLossRunReport(number: string, reportBy: string):any {
    return this.fileDownloadService.downloadLossRunReport(number, reportBy);
  }
  
  fetchPolicyDocumentList(request) {
    return this.commonService.fetchPolicyDocumentList(request);
  }

  fetchPolicyLob(policyNumber){
    return this.http.get<any>(ENDORSEMENT_URL.PolicyLOBType+"?policyNumber="+policyNumber, {observe: 'response'})
      .pipe(map(response => {
        return response.body.result;
    }));
  }
  endtTabFlag(selectedPolicy:any): Observable<boolean>{
    let endtFlag = new Subject<boolean>();
    if(selectedPolicy.showEndorsements == true || selectedPolicy.showEndorsements === false){
      endtFlag.next(selectedPolicy.showEndorsements);
    } else{
      if(this.commonService.checkPermission(Modules.PolicyEndtView)){
        this.fetchPolicyLob(selectedPolicy.policyNumber).subscribe(result=>{
          selectedPolicy.showEndorsements = result.canEndorse;
          endtFlag.next(selectedPolicy.showEndorsements);
        },error=>{
          selectedPolicy.showEndorsements = false;
        }
        );
      }else{
        selectedPolicy.showEndorsements = false;
        endtFlag.next(false);
      }
    }
    return endtFlag.asObservable();
  }

  downloadPolicyDocument(accountId, documentId, documentName="") {
    return this.fileDownloadService.downloadPolicyDocument(accountId, documentId, documentName);
  }

  openModal(modalType, modalName) {
    if(modalType === 'error'){
      this.modalService.openErrorModal();
    } else {
      this.modalService.openModal(modalName);
    }
  }

  closeModal() {
    this.modalService.closeModal();
  }

  hasOpenModals() {
    return this.modalService.hasOpenModals();
  }

  
}